module.exports = __webpack_public_path__ + "f6c396c95866da7ecdd6768ae48f0307.svg";


//////////////////
// WEBPACK FOOTER
// ./bower_components/footable/css/fonts/footable.svg
// module id = 1107
// module chunks = 1